export const doctorConsultationsTranslations = {
    en: {
        // Page Title
        doctorConsultationsFor: "Doctor consultations for",
        allCampaigns: "All Campaigns",

        // Table Headers
        srNo: "Sr. No.",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        patientName: "Patient Name",
        referralInformation: "Referral Information",
        advice: "Advice",
        findingsAndObservations: "Findings and Observations",
        taluka: "Taluka",
        district: "District",
        dateOfBirth: "Date of Birth",
        gender: "Gender",
        action: "Action",
        actions: "Actions",
        mobileNo: "Mobile No",
        email: "Email",
        aadharNumber: "Aadhar Number",
        date: "Date",
        registeredOn: "Registered On",
        status: "Status",

        // Eye camp tabs
        refractive: "Refractive",
        therapeutic: "Therapeutic",
        diagnostic: "Diagnostic",

        // Eye camp refractive table
        visionRe: "Vision RE",
        visionLe: "Vision LE",
        glassesRe: "Glasses RE (Sph/Cyl/Axis)",
        glassesLe: "Glasses LE (Sph/Cyl/Axis)",
        nearAdd: "Near Add",
        visionAt6m: "Vision at 6m",
        glassesPrescription: "Glasses Prescription",
        re: "RE",
        le: "LE",
        reSph: "RE Sph",
        reCyl: "RE Cyl",
        reAxis: "RE Axis",
        leSph: "LE Sph",
        leCyl: "LE Cyl",
        leAxis: "LE Axis",

        // Eye camp therapeutic/diagnostic table
        surgeryTypes: "Surgery Types",
        diagnosticTypes: "Diagnostic Types",

        // Row menu actions
        view: "View",
        statusChange: "Status Change",
        docUpload: "Doc Upload",
        editDiagnosisDetails: "Edit Diagnosis Details",

        // Buttons
        addConsultation: "Add Consultation",
        viewProfile: "View Profile",

        // Status
        campCompleted: "Camp Completed",

        // Drawer / Dialog Titles
        addDoctorConsultation: "Add Doctor consultation",
        viewDoctorConsultation: "View Doctor consultation",
        diagnosisStatusChange: "Diagnosis Status Change",
        uploadReferralDocument: "Upload Referral Document",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",

        // Module Name
        doctorConsultationsModule: "Doctor consultations",
    },
    mr: {
        // Page Title
        doctorConsultationsFor: "डॉक्टर सल्लामसलत",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        patientName: "रुग्णाचे नाव",
        referralInformation: "संदर्भ माहिती",
        advice: "सल्ला",
        findingsAndObservations: "निष्कर्ष आणि निरीक्षणे",
        taluka: "तालुका",
        district: "जिल्हा",
        dateOfBirth: "जन्मतारीख",
        gender: "लिंग",
        action: "क्रिया",
        actions: "क्रिया",
        mobileNo: "मोबाईल क्रमांक",
        email: "ईमेल",
        aadharNumber: "आधार क्रमांक",
        date: "दिनांक",
        registeredOn: "नोंदणी दिनांक",
        status: "स्थिती",

        // Eye camp tabs
        refractive: "अपवर्तक",
        therapeutic: "उपचारात्मक",
        diagnostic: "निदानात्मक",

        // Eye camp refractive table
        visionRe: "दृष्टी (उजवा डोळा)",
        visionLe: "दृष्टी (डावा डोळा)",
        glassesRe: "चष्मा (उजवा डोळा)",
        glassesLe: "चष्मा (डावा डोळा)",
        nearAdd: "निअर अ‍ॅड",
        visionAt6m: "6 मी. वर दृष्टी",
        glassesPrescription: "चष्मा प्रिस्क्रिप्शन",
        re: "उजवा",
        le: "डावा",
        reSph: "उजवा Sph",
        reCyl: "उजवा Cyl",
        reAxis: "उजवा Axis",
        leSph: "डावा Sph",
        leCyl: "डावा Cyl",
        leAxis: "डावा Axis",

        // Eye camp therapeutic/diagnostic table
        surgeryTypes: "शस्त्रक्रिया प्रकार",
        diagnosticTypes: "निदान प्रकार",

        // Row menu actions
        view: "पहा",
        statusChange: "स्थिती बदला",
        docUpload: "कागदपत्र अपलोड",
        editDiagnosisDetails: "निदान तपशील संपादित करा",

        // Buttons
        addConsultation: "सल्लामसलत जोडा",
        viewProfile: "प्रोफाइल पहा",

        // Status
        campCompleted: "शिबिर पूर्ण झाले",

        // Drawer / Dialog Titles
        addDoctorConsultation: "डॉक्टर सल्लामसलत जोडा",
        viewDoctorConsultation: "डॉक्टर सल्लामसलत पहा",
        diagnosisStatusChange: "निदान स्थिती बदला",
        uploadReferralDocument: "रेफरल कागदपत्र अपलोड करा",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",

        // Module Name
        doctorConsultationsModule: "डॉक्टर सल्लामसलत",
    }
};
